import { configureStore, applyMiddleware } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import { rootReducer } from './rootReducer';
import { rootSaga } from './rootSaga';


const sagaMiddleware = createSagaMiddleware()

export type ApplicationState = ReturnType<typeof rootReducer>

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) => getDefault(),
  enhancers: [applyMiddleware(sagaMiddleware)],
})

sagaMiddleware.run(rootSaga);
